import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";
import ReferralCodes from "./referral-codes";
import StaffReferralCodes from "./staff-referral-codes";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function DiscountHub() {
  const [activeTab, setActiveTab] = useState("referral-codes");

  const tabs = [
    {
      name: "Referral Codes",
      key: "referral-codes",
      href: "#referral-codes",
    },
    {
      name: "Exempted Staff Referral Codes",
      key: "staff-referral-codes",
      href: "#staff-referral-codes",
    },
  ];

  return (
    <Layout title="Discount Hub" pageTag="discount-hub" current="/discount-hub">
      <div className="max-w-7xl">
        <div className="mb-6">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={classNames(
                    activeTab === tab.key
                      ? "border-red-500 text-red-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                    "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                  )}
                >
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>
        </div>
        {activeTab === "referral-codes" ? <ReferralCodes /> : <StaffReferralCodes />}
      </div>
    </Layout>
  );
}
